import { ChevronLeft, ChevronRight } from 'lucide-react';
import { ACTIVITY_STATUS_BADGE, ACTIVITY_STATUS_LABELS } from './activityStatus';
import type { ActivityStatus } from '../../types/activity';

interface ActivityDetailHeaderProps {
  currentIndex: number;
  total: number;
  activityKey: string;
  status: ActivityStatus;
  /** Omitted when the title is edited inline below the header */
  title?: string;
  onPrev?: () => void;
  onNext?: () => void;
}

const navButton =
  'flex items-center gap-1 px-2.5 py-1 text-xs font-semibold rounded-md text-pine-ink-soft hover:text-pine-ink hover:bg-pine-hover-item disabled:opacity-30 disabled:cursor-not-allowed transition-colors border-[1.5px] border-pine-line';

export default function ActivityDetailHeader({
  currentIndex,
  total,
  activityKey,
  status,
  title,
  onPrev,
  onNext,
}: ActivityDetailHeaderProps) {
  return (
    <div data-testid="activity-detail-header" className="mb-6">
      <div className="flex items-center gap-3">
        <p className="uppercase tracking-[0.12em] font-bold text-pine-ink-soft text-[11px]">
          {currentIndex >= 0 ? `Activity ${currentIndex + 1} of ${total}` : 'Activity'}
        </p>
        <span className="text-[11px] font-semibold text-pine-ink-soft tabular-nums">{activityKey}</span>
        <span
          data-testid="activity-status-badge"
          className={`px-2.5 py-0.5 text-xs font-medium rounded-full ${ACTIVITY_STATUS_BADGE[status]}`}
        >
          {ACTIVITY_STATUS_LABELS[status]}
        </span>
        {(onPrev || onNext) && (
          <div className="flex items-center gap-1.5 ml-auto">
            <button
              type="button"
              onClick={onPrev}
              disabled={!onPrev || currentIndex <= 0}
              className={navButton}
            >
              <ChevronLeft className="w-3.5 h-3.5" /> Previous
            </button>
            <button
              type="button"
              onClick={onNext}
              disabled={!onNext || currentIndex < 0 || currentIndex >= total - 1}
              className={navButton}
            >
              Next <ChevronRight className="w-3.5 h-3.5" />
            </button>
          </div>
        )}
      </div>
      {title !== undefined && (
        <h1 className="font-display text-[31px] font-semibold text-pine-ink mt-2">{title}</h1>
      )}
    </div>
  );
}
